import React, { useState } from 'react';
import styled from 'styled-components';
import JsonLd from './shared/JsonLd';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  
  const faqSchema = {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": [
      {
        "@type": "Question",
        "name": "Do I need technical knowledge to benefit from the coaching session?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Not at all. Our coaching is specifically designed for business professionals without technical backgrounds. We translate complex AI concepts into business language and focus on practical applications rather than technical details."
        }
      },
      {
        "@type": "Question",
        "name": "How is this different from reading articles or watching videos about AI?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Generic resources provide general information, but our coaching is personalised to your specific business challenges, goals, and industry. We cut through the noise to identify exactly what will work for your unique situation, saving you countless hours of research and trial-and-error."
        }
      },
      {
        "@type": "Question",
        "name": "What happens after the 90 minutes session?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "You'll receive a detailed email summarising our discussion, including your personalised AI implementation roadmap, specific tool recommendations, and clear next steps. While the one-hour session is designed to be comprehensive, we also offer follow-up sessions for clients who want ongoing support during their implementation journey."
        }
      },
      {
        "@type": "Question",
        "name": "Is there a guarantee that AI will work for my specific needs?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "While we can't guarantee specific results as every business is unique, we can guarantee that you'll walk away with clarity on whether and how AI can benefit your specific situation. If we determine that AI isn't the right solution for your current challenges, we'll be honest about that and suggest alternative approaches."
        }
      },
      {
        "@type": "Question",
        "name": "Do you cover locations outside of the UK?",
        "acceptedAnswer": {
          "@type": "Answer",
          "text": "Yes, we are happy to have a conversation with you no matter where you are in the world."
        }
      }
    ]
  };

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <FAQSection id="faq">
      <JsonLd data={faqSchema} />
      <div className="container">
        <Title>Frequently Asked Questions</Title>
        <Subtitle>Get answers to common questions about our AI coaching services.</Subtitle>
        <FAQItem onClick={() => toggleFAQ(0)}>
          <Question>Do I need technical knowledge to benefit from the coaching session?</Question>
          {activeIndex === 0 && (
            <Answer>
              Not at all. Our coaching is specifically designed for business professionals without technical backgrounds. We translate complex AI concepts into business language and focus on practical applications rather than technical details.
            </Answer>
          )}
        </FAQItem>
        <FAQItem onClick={() => toggleFAQ(1)}>
          <Question>How is this different from reading articles or watching videos about AI?</Question>
          {activeIndex === 1 && (
            <Answer>
              Generic resources provide general information, but our coaching is personalised to your specific business challenges, goals, and industry. We cut through the noise to identify exactly what will work for your unique situation, saving you countless hours of research and trial-and-error.
            </Answer>
          )}
        </FAQItem>
        <FAQItem onClick={() => toggleFAQ(2)}>
          <Question>What happens after the 90 minutes session?</Question>
          {activeIndex === 2 && (
            <Answer>
              You'll receive a detailed email summarising our discussion, including your personalised AI implementation roadmap, specific tool recommendations, and clear next steps. While the one-hour session is designed to be comprehensive, we also offer follow-up sessions for clients who want ongoing support during their implementation journey.
            </Answer>
          )}
        </FAQItem>
        <FAQItem onClick={() => toggleFAQ(3)}>
          <Question>Is there a guarantee that AI will work for my specific needs?</Question>
          {activeIndex === 3 && (
            <Answer>
              While we can't guarantee specific results as every business is unique, we can guarantee that you'll walk away with clarity on whether and how AI can benefit your specific situation. If we determine that AI isn't the right solution for your current challenges, we'll be honest about that and suggest alternative approaches.
            </Answer>
          )}
        </FAQItem>
        <FAQItem onClick={() => toggleFAQ(4)}>
          <Question>Do you cover locations outside of the UK?</Question>
          {activeIndex === 4 && (
            <Answer>
              Yes, we are happy to have a conversation with you no matter where you are in the world.
            </Answer>
          )}
        </FAQItem>
       
      </div>
    </FAQSection>
  );
};

const FAQSection = styled.section`
  background-color: var(--white);
  padding: 4rem 0;
  text-align: center;
`;

const Title = styled.h2`
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  margin-bottom: 2rem;
`;

const FAQItem = styled.div`
  cursor: pointer;
  margin-bottom: 1rem;
  padding: 1rem;
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: var(--shadow);
  transition: background-color 0.3s;

  &:hover {
    background-color: #f9f9f9;
  }
`;

const Question = styled.h3`
  font-weight: bold;
  margin: 0;
`;

const Answer = styled.p`
  margin: 0;
  padding-top: 0.5rem;
  text-align: left;
`;

export default FAQ;
